import { render } from "./ContactArea.vue?vue&type=template&id=53109625"
import script from "./ContactArea.vue?vue&type=script&lang=js"
export * from "./ContactArea.vue?vue&type=script&lang=js"

import "./ContactArea.vue?vue&type=style&index=0&id=53109625&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__